import { desktopOnly, mobileOnly } from '../../lib/utils';
import BaseNextImage, { BaseNextImageProps } from './BaseNextImage';
import styled from '@emotion/styled';
const ImageWrapper = styled('div')`
  z-index: -1;
  width: 100%;
  justify-content: center;
`;

const DesktopThemeImageWrapper = desktopOnly(ImageWrapper, 'flex');
const MobileThemeImageWrapper = mobileOnly(ImageWrapper);

interface ThemeImageProps extends Omit<BaseNextImageProps, 'sizes'> {
  mobileSrc?: string;
  isTopImage?: boolean;
  desktopSizes?: string;
  mobileSizes?: string;
}

const ThemeNextImage = ({
  src,
  mobileSrc,
  id = '',
  alt,
  imageCSSObject,
  loading = 'lazy',
  priority = false,
  isTopImage = false,
  desktopSizes = '100vw',
  mobileSizes = '100vw',
  quality = 90,
  ...rest
}: ThemeImageProps) => {
  return (
    <>
      <DesktopThemeImageWrapper>
        <BaseNextImage
          id={id}
          src={src}
          alt={alt}
          loading={loading}
          priority={priority}
          fill
          imageFit="crop"
          preventStretch
          imageCSSObject={imageCSSObject}
          imagePositionRelative={!isTopImage}
          sizes={desktopSizes}
          dataTestId="ThemeImage__Desktop"
          quality={quality}
          {...rest}
        />
      </DesktopThemeImageWrapper>
      <MobileThemeImageWrapper>
        <BaseNextImage
          id={id}
          src={mobileSrc || src}
          alt={alt}
          loading={loading}
          priority={priority}
          fill
          imageFit="crop"
          preventStretch
          imageCSSObject={imageCSSObject}
          imagePositionRelative={!isTopImage}
          sizes={mobileSizes}
          dataTestId="ThemeImage__Mobile"
          quality={quality}
          {...rest}
        />
      </MobileThemeImageWrapper>
    </>
  );
};

export default ThemeNextImage;
